import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import StorefrontIcon from "@material-ui/icons/Storefront";
import api from "../../services/api";
import toastError from "../../errors/toastError";

export default function ConfiguredStoreShortcut({ label }) {
  const [opening, setOpening] = useState(false);
  const openStore = async () => {
    if (opening) return;
    setOpening(true);
    let popup;
    try {
      // Abrir durante el clic evita que el navegador móvil bloquee la pestaña.
      popup = window.open("about:blank", "_blank");
      if (popup) popup.opener = null;
      const { data } = await api.get("/negocio/storefront");
      const url = new URL(data.url);
      if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) throw new Error("La tienda no tiene una URL válida configurada.");
      if (popup && !popup.closed) popup.location.replace(url.href);
      else window.location.assign(url.href);
    } catch (error) {
      if (popup && !popup.closed) popup.close();
      toastError(error);
    } finally {
      setOpening(false);
    }
  };
  return <IconButton size="small" onClick={openStore} aria-label={label} aria-busy={opening} disabled={opening}>
    <StorefrontIcon fontSize="small" />
  </IconButton>;
}
